<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="已排产工单"
      :page="false"
      show-checkbox
      :show-query="true"
      :get-data-func="api.getWorkDocProductPlanList"
      @check-change="checkChange"
      urlHash="production/scheduling/equipmentscheduling/alreadyScheduling"
      :temp-params="tempParams"
      @getDataEnd="resetDataFunc"
    >
      <template slot="toolbar-right">
        <!-- <el-button type="primary" @click="editStartTime">修改开工时间</el-button> -->
        <!-- <el-button type="primary" @click="editClassTimes">修改班次</el-button> -->
        <!-- <el-button type="primary" @click="editTeam">修改班组班次</el-button> -->
      </template>
      <template slot="tabs">
        <el-tabs v-model="tabName" type="card" @tab-click="tabClick">
          <!-- <el-tab-pane :label="'注塑工单' + '(' + Injection.length + ')'" name="0"></el-tab-pane>
          <el-tab-pane :label="'胶件加工工单' + '(' + Special.length + ')'" name="1"></el-tab-pane>
          <el-tab-pane :label="'配件工单' + '(' + Parts.length + ')' " name="2"></el-tab-pane>
          <el-tab-pane :label="'装配工单' + '(' + Assembling.length + ')' " name="3"></el-tab-pane>
          <el-tab-pane :label="'组合工单' + '(' + Combination.length + ')' " name="4"></el-tab-pane> -->
          <el-tab-pane v-for="(item, index) in machiningStageList" :key="index" :label="item.Name + '工单' + '(' + item.Len + ')'" :name="item.MachiningStageId + ''"></el-tab-pane>
        </el-tabs>
      </template>
      <template slot="table">
        <el-table-column label="操作" fixed="right" align="center" width="240">
          <template slot-scope="{ row, $index }">
            <el-button v-if="$permission.canWrite() && row.SchedulingStatus === 0" type="text" @click="edit(row, $index)">查看</el-button>
            <el-button v-if="$permission.canWrite() && row.SchedulingStatus === 0 && dpid" :disabled="$index === 0" type="text" @click="move(row, 0)">上移</el-button>
            <el-button v-if="$permission.canWrite() && row.SchedulingStatus === 0 && dpid" :disabled="$index === notMoveDown" type="text" @click="move(row, 1)">下移</el-button>
            <el-button v-if="$permission.canWrite() && row.SchedulingStatus === 0" type="text" @click="back(row)">恢复到未排产状态</el-button>
          </template>
        </el-table-column>
      </template>
    </list>

    <team-dialog ref="teamDialog" @change="changeTeam"></team-dialog>
    <schedule-dialog ref="scheduleDialog"></schedule-dialog>

    <common-dialog ref="commonDialog" @changeTime="changeTime"></common-dialog>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import commonDialog from './commonDialog'
import teamDialog from './teamDialog'
import scheduleDialog from './scheduleDialog'

export default {
  mixins: [listMixin],
  components: { list, commonDialog, teamDialog, scheduleDialog },
  props: {
    dpid: {
      type: Number,
      default: null
    },
    OrderProductIds: {
      type: Array,
      default: () => []
    }
  },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/pu/plan').default,
      // calendarApi: require('@/api/ba/calendar').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,

      params: {
        Order: '',
        SubOrder: '',
        CustomerName: '',
        DocTime: '',
        StockName: '',
        Remark: '',
        Department: '',
        Salesman: ''
      },
      tempParams: {
        SchedulingType: 1,
        IsScheduling: true,
        MaintenanceId: null,
        OrderProductIds: []
      },
      result: {},
      index: 0,
      data: {},
      type: 0,
      _dpid: null,
      selectList: [],
      tabName: '0',
      Combination: [],
      Assembling: [],
      Parts: [],
      Special: [],
      Injection: [],
      machiningStageList: []
    }
  },
  watch: {
    OrderProductIds(val) {
      this.tempParams.OrderProductIds = val
      this.subTableEnter()
    },
    dpid(val) {
      this.tempParams.MaintenanceId = val
      this.subTableEnter()
    }
  },
  computed: {
    notMoveDown() {
      let data = []

      // if (this.tabName === '0') data = this.Injection
      // if (this.tabName === '1') data = this.Special
      // if (this.tabName === '2') data = this.Parts
      // if (this.tabName === '3') data = this.Assembling
      // if (this.tabName === '4') data = this.Combination
      var stage = this.machiningStageList.find(x => x.MachiningStageId == Number(this.tabName))
      if (stage) data = stage.datas
      return data.length - 1
    }
  },
  created() {
    this.machiningStageApi.list({ Status: 1 }).then(res => {
      this.machiningStageList = res.Data
      this.machiningStageList.forEach(x => {
        if (x.MachiningStageId == 1) {
          x.MachiningStageId = 0
        }
        x.Len = 0
        x.datas = []
      })
    })
  },
  methods: {
    move(row, type) {
      let o = {
        OperationType: type,
        ReferentPlanId: 0,
        TargetPlanId: row.PlanId
      }
      let index = 0
      var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
      if (stage) {
        index = stage.datas.findIndex(item => {
          return row.PlanId === item.PlanId
        })
        o.ReferentPlanId = type === 0 ? stage.datas[index - 1].PlanId : stage.datas[index + 1].PlanId
      }
      // switch (this.tabName) {
      //   case '0':
      //     index = this.Injection.findIndex(item => {
      //       return row.PlanId === item.PlanId
      //     })
      //     o.ReferentPlanId = type === 0 ? this.Injection[index - 1].PlanId : this.Injection[index + 1].PlanId
      //     break
      //   case '1':
      //     index = this.Special.findIndex(item => {
      //       return row.PlanId === item.PlanId
      //     })
      //     o.ReferentPlanId = type === 0 ? this.Special[index - 1].PlanId : this.Special[index + 1].PlanId
      //     break
      //   case '2':
      //     index = this.Parts.findIndex(item => {
      //       return row.PlanId === item.PlanId
      //     })
      //     o.ReferentPlanId = type === 0 ? this.Parts[index - 1].PlanId : this.Parts[index + 1].PlanId
      //     break
      //   case '3':
      //     index = this.Assembling.findIndex(item => {
      //       return row.PlanId === item.PlanId
      //     })
      //     o.ReferentPlanId = type === 0 ? this.Assembling[index - 1].PlanId : this.Assembling[index + 1].PlanId
      //     break
      //   case '4':
      //     index = this.Combination.findIndex(item => {
      //       return row.PlanId === item.PlanId
      //     })
      //     o.ReferentPlanId = type === 0 ? this.Combination[index - 1].PlanId : this.Combination[index + 1].PlanId
      //     break
      // }

      var loading = this.$loading({
        lock: true,
        text: '正在取消...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })

      this.api
        .changeSn(o)
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.subTableEnter()
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    back(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在取消...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      console.log('planId: row.PlanId', row.PlanId, row)
      this.api
        .schedulingCancel({ planId: row.PlanId })
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.$emit('end')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    changeTime() {
      this.subTableEnter(this.tempParams.OrderProductIds)
    },
    changeTeam() {
      this.subTableEnter(this.tempParams.OrderProductIds)
    },
    addIndex(arr) {
      arr.forEach((item, i) => {
        item.indexNumber = i + 1
      })

      return arr
    },
    setInjection(data) {
      data.forEach(item => {
        item.ProductName = item.MouldName
        item.ProductNo = item.MouldNo
      })

      return data
    },
    resetDataFunc(resData) {
      let Combination = []
      let Assembling = []
      let Parts = []
      let Special = []
      let Injection = []

      let data = resData
      console.log(data,"reset");
      let length = data.length

      let dps = data.map(item => {
        return item.MaintenanceName
      })

      dps = Array.from(new Set(dps))

      dps = dps.filter(item => {
        return item != null
      })

      let arr = []
      dps.forEach(item => {
        let arr1 = data.filter(v => {
          return item === v.MaintenanceName
        })
        let o = {
          dps: arr1
        }
        arr.push(o)
      })

      let dpSelect = []
      arr.forEach(item => {
        let o = {
          ProductionDpId: item.dps[0]?.MaintenanceId,
          ProductionDpName: item.dps[0]?.MaintenanceName,
          ProductionDpNumber: item.dps.length
        }
        dpSelect.push(o)
      })

      this.$emit('getDp', dpSelect)
      // for (let i = 0; i < length; ++i) {
      //   let stage = data[i].Stage;
      //   switch (stage) {
      //     case 0:
      //       Injection.push(data[i]);
      //       break;
      //     case 1:
      //       Special.push(data[i]);
      //       break;
      //     case 2:
      //       Parts.push(data[i]);
      //       break;
      //     case 3:
      //       Assembling.push(data[i]);
      //       break;
      //     case 4:
      //       Combination.push(data[i]);
      //       break;
      //   }
      // }

      // this.Combination = this.addIndex(Combination);
      // this.Assembling = this.addIndex(Assembling);
      // this.Parts = this.addIndex(Parts);
      // this.Special = this.addIndex(Special);
      // Injection = this.setInjection(Injection)
      // this.Injection = this.addIndex(Injection);

      // if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
      // if (this.tabName === "1") this.$refs.list.setTable(this.Special);
      // if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
      // if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
      // if (this.tabName === "4") this.$refs.list.setTable(this.Combination);

      this.machiningStageList.forEach((x, index) => {
        console.log(x, x.MachiningStageId, 'ss')
        var list = data.filter(w => w.Stage == x.MachiningStageId)
        console.log(list, data, 'list')
        if (x.MachiningStageId == 0) {
          list = this.setInjection(list)
        }
        x.datas = this.addIndex(list)
        // x.datas.forEach(row => {
        //   var maintenances = row.PlanDts.map(x => x.MaintenanceName)
        //   var schedules = row.PlanDts.map(x => x.Schedule)
        //   var teams = row.PlanDts.map(x => x.Team)
        //   row.Maintenance = maintenances.join(',')
        //   row.Schedule = schedules.join(',')
        //   row.Team = teams.join(',')
        // })

        console.log(x.datas, 'x.datas')
        x.Len = x.datas.length
        this.$set(this.machiningStageList, index, x)
      })

      var stage = this.machiningStageList.find(x => x.MachiningStageId == Number(this.tabName))
      if (stage) this.$refs.list.setTable(stage.datas)

      this.$emit('listEnd', {
        Combination: this.Combination,
        Assembling: this.Assembling,
        Parts: this.Parts,
        Special: this.Special,
        Injection: this.Injection
      })
    },
    subTableEnter(OrderProductIds) {
      // this.tempParams.OrderProductIds = OrderProductIds;
      this.$refs.list.getData()
      var data = this.$refs.list.data
      console.log(data, 'sutableenter')
      this.machiningStageList.forEach((x, index) => {
        var list = data.filter(w => w.Stage == x.MachiningStageId)
        if (list) {
          if (x.MachiningStageId == 0) {
            list = this.setInjection(list)
          }
          x.datas = this.addIndex(list)
          x.Len = x.datas.length
        } else {
          x.datas = []
          x.Len = 0
        }
        this.$set(this.machiningStageList, index, x)
      })
      var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
      if (stage) {
        this.$refs.list.setTable(stage.datas)
      }
      // 根据勾选的内容搜索
      // var loading = this.$loading({
      //   lock: true,
      //   text: "正在更新...",
      //   spinner: "el-icon-loading",
      //   customClass: "my_loading",
      //   background: "rgba(0, 0, 0, 0.3)",
      // });
      // let data = {};
      // if(this.tempParams.ProductionDpId === 0 || this.tempParams.ProductionDpId == null){
      //   data = { OrderProductIds: OrderProductIds, SchedulingType: 0, IsScheduling: true }
      // }else{
      //   data = { OrderProductIds: OrderProductIds, SchedulingType: 0, IsScheduling: true, ProductionDpId: this.tempParams.ProductionDpId }
      // }
      // this.api
      //   .proList(data)
      //   .then((res) => {
      //     console.log("res", res);
      //     if (res.Code === 0) {

      //       let Combination = [];
      //       let Assembling = [];
      //       let Parts = [];
      //       let Special = [];
      //       let Injection = [];

      //       let data = res.Data;
      //       let length = data.length;

      //       let dps = data.map(item => {
      //         return item.ProductionDpName;
      //       })

      //       dps = Array.from(new Set(dps));

      //       dps = dps.filter(item => {
      //         return item != null
      //       })

      //       let arr = [];
      //       dps.forEach(item => {
      //         let arr1 = data.filter(v => {
      //           return item === v.ProductionDpName;
      //         })
      //         let o = {
      //           dps: arr1,
      //         }
      //         arr.push(o)
      //       })

      //       let dpSelect = [];
      //       arr.forEach(item => {
      //         let o = {
      //           ProductionDpId:item.dps[0]?.ProductionDpId,
      //           ProductionDpName:item.dps[0]?.ProductionDpName,
      //           ProductionDpNumber:item.dps.length,
      //         }
      //         dpSelect.push(o)
      //       })

      //       this.$emit('getDp', dpSelect)
      //       for (let i = 0; i < length; ++i) {
      //         let stage = data[i].Stage;
      //         switch (stage) {
      //           case 0:
      //             Injection.push(data[i]);
      //             break;
      //           case 1:
      //             Special.push(data[i]);
      //             break;
      //           case 2:
      //             Parts.push(data[i]);
      //             break;
      //           case 3:
      //             Assembling.push(data[i]);
      //             break;
      //           case 4:
      //             Combination.push(data[i]);
      //             break;
      //         }
      //       }

      //       this.Combination = Combination;
      //       this.Assembling = Assembling;
      //       this.Parts = Parts;
      //       this.Special = Special;
      //       this.Injection = Injection;

      //       if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
      //       if (this.tabName === "1") this.$refs.list.setTable(this.Special);
      //       if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
      //       if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
      //       if (this.tabName === "4") this.$refs.list.setTable(this.Combination);

      //       this.$emit('listEnd', {
      //         Combination: this.Combination,
      //         Assembling: this.Assembling,
      //         Parts: this.Parts,
      //         Special: this.Special,
      //         Injection: this.Injection,

      //       })

      //     }

      //     loading.close()

      //   }).catch(err => {
      //     loading.close()
      //   })
    },
    setTabData(data) {
      let { Combination, Assembling, Parts, Special, Injection } = data
      this.Combination = Combination
      this.Assembling = Assembling
      this.Parts = Parts
      this.Special = Special
      this.Injection = Injection

      if (this.tabName === '0') this.$refs.list.setTable(this.Injection)
      if (this.tabName === '1') this.$refs.list.setTable(this.Special)
      if (this.tabName === '2') this.$refs.list.setTable(this.Parts)
      if (this.tabName === '3') this.$refs.list.setTable(this.Assembling)
      if (this.tabName === '4') this.$refs.list.setTable(this.Combination)
    },
    tabClick() {
      console.log('tab', this.tabName)
      var stage = this.machiningStageList.find(x => x.MachiningStageId == this.tabName)
      if (stage) this.$refs.list.setTable(stage.datas)
      // if (this.tabName === "0") this.$refs.list.setTable(this.Injection);
      // if (this.tabName === "1") this.$refs.list.setTable(this.Special);
      // if (this.tabName === "2") this.$refs.list.setTable(this.Parts);
      // if (this.tabName === "3") this.$refs.list.setTable(this.Assembling);
      // if (this.tabName === "4") this.$refs.list.setTable(this.Combination);
    },
    checkChange(arr) {
      this.selectList = arr
    },

    _getData() {
      this.getData()
    },
    edit(row, index) {
      let { WorkDocId, TeamId, Team, ScheduleId, Schedule, PrPlanDtsList, Quantity ,Stage,
        OrderNo,
        WorkDocNo,
        BatchNumber,
        ProductNo,
        ProductName,
        ProductSpec,
       } = row
      let arr = []
      arr.push(WorkDocId)
      let o = {
        WorkDocIds: arr,
        TeamId,
        Team,
        ScheduleId,
        Schedule,
        PlanDts: PrPlanDtsList,
        Quantity,
        index,
        IsDetail: true,
        Stage ,
        OrderNo,
        WorkDocNo,
        BatchNumber,
        ProductNo,
        ProductName,
        ProductSpec,
      }

      this.$refs.scheduleDialog.openEdit(o)
    },
    editTeam() {
      if (this.selectList.length === 0) {
        this.$message({ type: 'warning', message: '请勾选要修改的项目' })
        return
      }

      let WorkDocIds = this.selectList.map(item => {
        return item.WorkDocId
      })

      let o = {
        WorkDocIds: WorkDocIds,
        TeamId: null,
        Team: '',
        ScheduleId: null,
        Schedule: ''
      }
      this.$refs.teamDialog.openEdit(o)
    },
    editStartTime() {
      if (this.selectList.length === 0) {
        this.$message({ type: 'warning', message: '请勾选要修改的项目' })
        return
      }
      let PlanIds = this.selectList.map(item => {
        return item.PlanId
      })
      let o = {
        PlanIds,
        StartDate: ''
      }
      this.$refs.commonDialog.openEdit(o)
    },
    editClassTimes() {
      if (this.selectList.length === 0) {
        this.$message({ type: 'warning', message: '请勾选要修改的项目' })
        return
      }
      let WorkDocIds = this.selectList.map(item => {
        return item.WorkDocId
      })

      let o = {
        WorkDocIds: WorkDocIds,
        TeamId: null,
        Team: '',
        ScheduleId: null,
        Schedule: ''
      }
      this.$refs.scheduleDialog.openEdit(o)
    }
  }
}
</script>
